import { render } from "./AppCardLink.vue?vue&type=template&id=767eef5a&scoped=true&ts=true"
import script from "./AppCardLink.vue?vue&type=script&lang=ts"
export * from "./AppCardLink.vue?vue&type=script&lang=ts"

import "./AppCardLink.vue?vue&type=style&index=0&id=767eef5a&lang=scss&scoped=true"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767eef5a"]])

export default __exports__